// Chat message rules (decision 2026-09-27): players have a 160-character limit and may not share
// links. Administrators and moderators are exempt. Checked by the server; the UI uses the same
// rules for immediate feedback.
import { isStaff, limits, type Role } from './protocol.js';

export const PLAYER_CHAT_MAX = 160;

export function chatMaxLength(role: Role): number {
  return isStaff(role) ? limits.chatMessageMax : PLAYER_CHAT_MAX;
}

// http(s)://…, www.…, bare domains like "example.fi" or "some-site.com/path", IPv4 addresses.
const LINK_PATTERNS: RegExp[] = [
  /\b(?:https?|ftp):\/\//i,
  /\bwww\s*\.\s*[a-z0-9-]/i,
  /\b[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.(?:[a-z0-9-]+\.)*[a-z]{2,12}\b(?:[/:?#]|\s|$)/i,
  /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/,
];

export function containsLink(text: string): boolean {
  return LINK_PATTERNS.some((p) => p.test(text));
}

export type ChatRuleError = 'message_too_long' | 'links_not_allowed';

export function checkChatMessage(text: string, role: Role): ChatRuleError | null {
  if (text.length > chatMaxLength(role)) return 'message_too_long';
  if (!isStaff(role) && containsLink(text)) return 'links_not_allowed';
  return null;
}
